const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/ReportsCard/SmallReportsCard.tsx';
import React from 'react';
import textMap from 'App/pages/DashboardPage/translations';
import { useHistory } from 'react-router';
import { goToReports } from 'App/utils/history';
import { useReports } from 'App/store/documents';
import { DashboardCard } from '../DashboardCard';
import { CardNavigationLink } from '../CardNavigationLink';

export const SmallReportsCard = (props: any) => {
    const history = useHistory();
    const { data: reports, isPendingOrLoading: isDataLoading } = useReports();
    const hasData = !!reports?.length;

    const handleClick = () => goToReports(history);

    return (
        <DashboardCard
            iconClass="icons8-document"
            onClick={handleClick}
            isDataLoading={isDataLoading}
            hasData={hasData}
        >
            <CardNavigationLink text={textMap.ReportsBtn} />
        </DashboardCard>
    );
};

export default SmallReportsCard;
